import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-6 relative overflow-hidden" data-id="element-85">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-86">
        <FadeIn data-id="element-87">
          <span className="inline-block py-1 px-3 rounded-full bg-sage/20 text-sage font-semibold text-sm tracking-wider uppercase mb-6" data-id="element-88">
            Para Mujeres +35
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-89">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-90">
            Protocolo Flash Anti-Inflamación (48h): El Reset Metabólico
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-91">
          <h2 className="text-xl md:text-2xl text-charcoal/80 font-playfair italic mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-92">
            Recupera la ligereza en tu abdomen y vuelve a cerrar tus pantalones
            favoritos antes de que suene la alarma del lunes.
          </h2>
        </FadeIn>

        <FadeIn delay={0.25} className="flex justify-center mb-10" data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/cR1zRpMq57baWBofJSA7rc/ChatGPT_Image_Feb_28,_2026,_10_53_39_PM.png" alt="Protocolo Flash Anti-Inflamación 48H - Vista previa en tablet" className="w-full max-w-sm md:max-w-md rounded-2xl shadow-2xl" data-id="element-94" />
        </FadeIn>

        <FadeIn delay={0.35} className="flex flex-col items-center" data-id="element-95">
          <CTAButton className="w-full md:w-auto mb-4" onClick={scrollToPricing} data-id="element-96">
            DESCARGA MI PROTOCOLO 48h AHORA
          </CTAButton>
          <p className="text-sm text-warmgray flex items-center gap-2" data-id="element-97">
            <span className="w-2 h-2 rounded-full bg-sage" data-id="element-98"></span>
            Acceso instantáneo en PDF tras el pago.
          </p>

          <div className="mt-6 flex items-center gap-3 bg-white/70 backdrop-blur-sm rounded-full py-2.5 px-5 shadow-sm border border-sage/10" data-id="element-99">
            <div className="flex -space-x-2" data-id="element-100">
              {['C', 'V', 'A', 'G'].map((letter, i) => <div key={i} className="w-7 h-7 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white" style={{
              backgroundColor: ['#C4704B', '#7C9A82', '#2D2A26', '#C4704B'][i],
              zIndex: 4 - i
            }} data-id="element-101">
                  {letter}
                </div>)}
            </div>
            <p className="text-sm text-charcoal" data-id="element-102">
              <span className="font-bold" data-id="element-103">+1,247</span> mujeres ya lo
              descargaron
            </p>
          </div>
        </FadeIn>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none opacity-30" data-id="element-104">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-terracotta/10 blur-3xl" data-id="element-105"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-sage/10 blur-3xl" data-id="element-106"></div>
      </div>
    </section>;
}